import { Menu } from "@headlessui/react";
import { NavLink, useLocation, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCheck } from "@fortawesome/pro-solid-svg-icons";
import classNames from "classnames";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSlugs } from "../hooks/useSlugs";
import { useAuthorizedLocations } from "../hooks/useAuthorizedLocations";

export const LocationMenu = () => {
  const location = useLocation();
  const [search] = useSearchParams();
  const {brandSlug, locationSlug} = useSlugs();
  const locations = useAuthorizedLocations(brandSlug);
  const [suffix, setSuffix] = useState("");
  const locationsData = locations
    ?.map(l => ({
      ...l,
      isCurrent: l.urlSlug === locationSlug,
    })) ?? [];
  const current = locationsData.find(d => d.isCurrent);

  useEffect(() => {
    if (!locationSlug) {
      return;
    }

    const parts = location.pathname
      .split("/");

    let suffix = parts
      .slice(parts.indexOf(locationSlug) + 1, parts.length)
      .join("/");

    if (search.values()) {
      suffix += `?${search.toString()}`;
    }

    setSuffix(suffix);
  }, [locationSlug, location, search]);

  if (!locations?.length) {
    return null;
  }

  return (
    <Menu>
      <div className="flex-grow h-full md:max-w-lg relative md:border-r
        border-gray-400">
        <Menu.Button className="w-full h-8 md:h-14 text-left md:p-2"
          title={t`Location`}>
          <div className="flex justify-between items-center">
            {current?.name ?? t`Choose One`}
            <FontAwesomeIcon icon={faCaretDown} className="ui-open:block
              ui-open:rotate-180 transition-all"/>
          </div>
        </Menu.Button>
        <Menu.Items className="fixed top-16 left-0 right-0 bottom-0 md:absolute
          md:w-full md:top-auto md:left-auto md:right-auto md:bottom-auto
          md:max-h-content border border-gray-400 text-black bg-white z-40
          overflow-y-auto">
          {locationsData.map((d, i) => <Menu.Item key={i}>
            {({close}) =>
              <NavLink to={`/${brandSlug}/${d.urlSlug}/${suffix}`} onClick={close}
                replace={true} className={classNames(
                  "underline w-full block p-2",
                  d.isCurrent
                    ? "bg-unleashed-pink text-white ui-active:bg-transparent " +
                      "ui-active:text-unleashed-pink flex justify-between " +
                      "items-center"
                    : "text-gray-500 ui-active:text-unleashed-pink"
                )}>
                {d.name}
                {
                  d.isCurrent &&
                  <FontAwesomeIcon icon={faCheck}/>
                }
              </NavLink>
            }
          </Menu.Item>)}
        </Menu.Items>
      </div>
    </Menu>
  );
};
